import { SxProps, TableRow, TableCell, TextField, Tooltip, Typography, IconButton } from '@mui/material';
import { Product } from 'shared/types/quotes';
import { defaultProduct } from 'shared/constants/quotes';
import React from 'react';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';

const fieldStyles: SxProps = { backgroundColor: '#FFFFFF' };

const cellStyles: SxProps = {
  padding: {
    xs: '5px',
    md: '6px 16px',
  },
};
interface ProductInputRowProps {
  handleAddRow: (newRow: Product) => void;
}
export const ProductInputRow = ({ handleAddRow }: ProductInputRowProps) => {
  const [newRow, setNewRow] = React.useState<Product>(defaultProduct);
  const disableAdd = !newRow.modelNumber;
  return (
    <TableRow>
      <TableCell sx={cellStyles}>
        <TextField
          sx={fieldStyles}
          placeholder='Total Quantity'
          type='number'
          size='small'
          value={newRow.totalQty}
          onChange={e => setNewRow(prev => ({ ...prev, totalQty: parseFloat(e.target.value || '0') }))}
        />
      </TableCell>
      <TableCell sx={cellStyles}>
        <TextField
          sx={fieldStyles}
          placeholder='Min Order Qty'
          type='number'
          size='small'
          value={newRow.minOrderQty}
          onChange={e => setNewRow(prev => ({ ...prev, minOrderQty: parseFloat(e.target.value || '0') }))}
        />
      </TableCell>
      <TableCell sx={cellStyles}>
        <TextField
          sx={fieldStyles}
          placeholder='Model Name'
          size='small'
          value={newRow.modelName}
          onChange={e => setNewRow(prev => ({ ...prev, modelName: e.target.value }))}
        />
      </TableCell>
      <TableCell sx={cellStyles}>
        <TextField
          sx={fieldStyles}
          placeholder='Tag #'
          size='small'
          value={newRow.tag}
          onChange={e => setNewRow(prev => ({ ...prev, tag: e.target.value }))}
        />
      </TableCell>
      <TableCell sx={cellStyles}>
        <TextField
          sx={fieldStyles}
          placeholder='Model No. *'
          size='small'
          value={newRow.modelNumber}
          onChange={e => setNewRow(prev => ({ ...prev, modelNumber: e.target.value }))}
        />
      </TableCell>
      <TableCell sx={cellStyles}>
        <TextField
          sx={fieldStyles}
          placeholder='Requested Pricing'
          size='small'
          value={newRow.requestedPrice}
          onChange={e => setNewRow(prev => ({ ...prev, requestedPrice: parseFloat(e.target.value || '0') }))}
        />
      </TableCell>
      <TableCell sx={cellStyles}>
        <TextField
          sx={fieldStyles}
          placeholder='Color'
          size='small'
          value={newRow.color}
          onChange={e => setNewRow(prev => ({ ...prev, color: e.target.value }))}
        />
      </TableCell>
      <TableCell sx={cellStyles}>
        <TextField
          sx={fieldStyles}
          placeholder='Options'
          size='small'
          value={newRow.options}
          onChange={e => setNewRow(prev => ({ ...prev, options: e.target.value }))}
          multiline
        />
      </TableCell>
      <TableCell sx={cellStyles}>
        <Tooltip title={<Typography variant='body2'>{disableAdd ? 'Missing required fields' : 'Save'}</Typography>}>
          <span>
            <IconButton
              onClick={() => {
                handleAddRow(newRow);
                setNewRow(defaultProduct);
              }}
              disabled={disableAdd}
            >
              <AddCircleOutlinedIcon color={disableAdd ? 'disabled' : 'success'} />
            </IconButton>
          </span>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};
